module.exports = __webpack_public_path__ + "static/img/2-0-order.185ef3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-0-order.png
// module id = 1312
// module chunks = 0